import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_pagePrev",
  "use": "icon_pagePrev-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 48 48\" id=\"icon_pagePrev\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M29.496 14.597c.7.765.667 1.97-.074 2.693L22.534 24l6.886 6.71c.742.723.775 1.928.075 2.693-.7.765-1.868.8-2.61.077l-8.307-8.095c-.37-.36-.579-.86-.579-1.385s.21-1.025.579-1.385l8.307-8.095a1.806 1.806 0 012.61.077z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol